const MonogramSeal = ({ sealText = "HISTORIA · IDENTIDAD · DISEÑO · ALQUIMIA ·" }) => (
  <svg className="seal" viewBox="0 0 560 560" aria-hidden="true" focusable="false">
    <defs>
      <path id="seal-circ" d="M 280,74 a 206,206 0 1,1 -0.01,0" />
      <radialGradient id="seal-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#D8C6A4" stopOpacity="0.14" />
        <stop offset="70%" stopColor="#D8C6A4" stopOpacity="0.04" />
        <stop offset="100%" stopColor="#D8C6A4" stopOpacity="0" />
      </radialGradient>
    </defs>
    <circle cx="280" cy="280" r="278" fill="url(#seal-glow)" />
    <circle cx="280" cy="280" r="252" fill="none" stroke="#D8C6A4" strokeOpacity="0.4" strokeWidth="1" />
    <g className="spin-slower">
      <circle cx="280" cy="280" r="232" fill="none" stroke="#D8C6A4" strokeOpacity="0.5" strokeWidth="1" strokeDasharray="2 10" />
    </g>
    <g className="spin-slow">
      <text fontSize="15" letterSpacing="7" fill="#D8C6A4" fillOpacity="0.85" fontFamily="'JetBrains Mono', monospace">
        <textPath href="#seal-circ" startOffset="0">
          {sealText}
        </textPath>
      </text>
    </g>
    <circle cx="280" cy="280" r="158" fill="none" stroke="#D8C6A4" strokeOpacity="0.35" strokeWidth="1" />
    <g fill="#D8C6A4" fillOpacity="0.9">
      <path d="M280 108 l5 8 -5 8 -5-8 z" />
      <path d="M280 436 l5 8 -5 8 -5-8 z" />
      <path d="M108 280 l8 5 -8 5 -8-5 z" />
      <path d="M436 280 l8 5 -8 5 -8-5 z" />
    </g>
    <text x="280" y="336" textAnchor="middle" fontFamily="'Instrument Serif', Georgia, serif" fontStyle="italic" fontSize="170" fill="#F2EEE6" letterSpacing="-4">
      CS
    </text>
  </svg>
);

export default MonogramSeal;
